export const Yetki = {
  SUPERADMİN: 1024,
  ADMIN: 512,
  BOLGE: 128,
  ULKE: 96,
  IL: 64,
  ILCE: 32,
  HOCA: 16,
  TALEBE: 8,
  YETKIYOK: 2
}

export const DersDurum = {
  BASLAMADI: 0,
  BASLAYACAK: 1,
  BASLADI: 2,
  BITECEK: 3,
  BITTI: 4,
  IPTAL: 5
}
